import {Vue} from "ui.vue";
import Order from './components/app.vue';
import PaymentBlock from './components/PaymentBlock.vue';
import OrderPriceBlock from './components/OrderPriceBlock.vue';
import Coupon from './components/Coupon.vue';
import "citrus.vue.dialog";
import CitrusDatePickDelivery from "./components/CitrusDatePickDelivery.vue";

Vue.cloneComponent('CitrusDatePickDelivery', 'CitrusDatePick', CitrusDatePickDelivery);
Vue.component('PaymentBlock', PaymentBlock);
Vue.component('OrderPriceBlock', OrderPriceBlock);
Vue.component('CitrusOrderCoupon', Coupon);
Vue.component('CitrusOrder', Order);

export {
	Order as CreateFromComponent
};
